export const CLAIM_CONFIG = {
    TERMS: 'https://support.immutable.com/hc/en-us/articles/9405981309199-Immutable-X-Third-Party-Digital-Wallets',
    PLAY_TO_EARN:
        'https://support.immutable.com/hc/en-us/articles/9405981309199-Immutable-X-Third-Party-Digital-Wallets',
    TOTAL_POINTS: 94032651,
    ALPHA_CAMPAIGN_TOTAL_IMX: 400000000,
    ENDPOINT: (host: string) => `${host}/rewards`,
    CHECK_STATUS: (status: string) => status === 'unclaimed',
};
